import { render, staticRenderFns } from "./afterSaleContract.vue?vue&type=template&id=0d71327c&scoped=true&"
import script from "./afterSaleContract.vue?vue&type=script&lang=js&"
export * from "./afterSaleContract.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleContract.vue?vue&type=style&index=0&id=0d71327c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71327c",
  null
  
)

export default component.exports